__turbopack_context__.v({
  "blocksBackgroundColor": "LocationBlockItem-module-scss-module__HOabaa__blocksBackgroundColor",
  "blocksFontColor": "LocationBlockItem-module-scss-module__HOabaa__blocksFontColor",
  "insertSection": "LocationBlockItem-module-scss-module__HOabaa__insertSection",
  "mapInsert": "LocationBlockItem-module-scss-module__HOabaa__mapInsert",
  "secondaryNavBackgroundColor": "LocationBlockItem-module-scss-module__HOabaa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "LocationBlockItem-module-scss-module__HOabaa__themeBackgroundColor",
  "themeFontColor": "LocationBlockItem-module-scss-module__HOabaa__themeFontColor",
});
